import React, { Component } from 'react'
import { Button } from 'antd'
import { connect } from 'react-redux'
import { switchPages } from '../../../actions'

@connect(
  null,
  { switchPages },
)
class Body extends Component {
  render() {
    return (
      <div style={{ marginTop: '40px', marginLeft: '20px' }}>
        <div className="row">
          <div className="col-md-12 text-center">
            <Button onClick={() => this.props.switchPages('transfer')}>Transfer</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default Body



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/BalanceScreen/Body/index.js